<template>
  <el-drawer
    :model-value="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :with-header="false"
    :before-close="handleClose"
    :size="300"
  >
    <section class="drawer-container">
      <section class="config-wrap">
        <h3 class="title">导航模式</h3>
        <section class="layout-wrap">
          <section
            v-for="item of layoutList"
            :key="item"
            :class="[
              'layout__item',
              item
            ]"
            @click="changeLayout(item)"
          >
            <span
              v-if="layout===item"
              class="checked-wrap"
            >
              <svg-icon
                icon-class="icon-check"
              />
            </span>
          </section>
        </section>
        <el-divider />
        <h3 class="title">顶部导航背景色</h3>
        <section class="colors-wrap">
          <section
            v-for="colorInfo of navbarBackgroundColors"
            :key="colorInfo.key"
            class="color-item"
            :style="{background: colorInfo.background}"
            @click="changeBackground(colorInfo, 1)"
          >
            <span
              v-if="navbarBackgroundInfo.key === colorInfo.key"
              :class="[
                'checked-wrap',
                colorInfo.key === 'default' ? 'default' : 'dark'
              ]"
            >
              <svg-icon
                icon-class="icon-check"
              />
            </span>
          </section>
        </section>
        <el-divider />
        <h3 class="title">侧边导航背景色</h3>
        <section class="colors-wrap">
          <section
            v-for="colorInfo of sidebarBackgroundColors"
            :key="colorInfo.key"
            class="color-item"
            :style="{background: colorInfo.background}"
            @click="changeBackground(colorInfo, 2)"
          >
            <span
              v-if="sidebarBackgroundInfo.key === colorInfo.key"
              :class="[
                'checked-wrap',
                colorInfo.key === 'default' ? 'default' : 'dark'
              ]"
            >
              <svg-icon
                icon-class="icon-check"
              />
            </span>
          </section>
        </section>
        <el-divider />
        <h3 class="title">系统颜色</h3>
        <el-form :label-width="80">
          <el-row>
            <el-col
              v-for="(value, key) in themeColors"
              :key="key"
              :span="12"
            >
              <el-form-item :label="`${key}:`">
                <el-color-picker
                  v-model="themeColors[key]"
                  :predefine="predefineColors"
                  @change="elColorChangeHandle"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-divider />
        <h3 class="title">字体颜色</h3>
        <el-form :label-width="90">
          <el-row>
            <el-col
              v-for="(value, key) in textColors"
              :key="key"
              :span="12"
            >
              <el-form-item :label="`${key}:`">
                <el-color-picker
                  v-model="textColors[key]"
                  :predefine="predefineColors"
                  @change="elColorChangeHandle"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-divider />
        <h3 class="title">内容区域</h3>
        <section>
          <section class="config-item">
            <span>使用面包屑</span>
            <el-switch
              v-model="useBreadcrumb"
              @change="changeHandle($event, 1)"
            />
          </section>

          <section class="config-item">
            <span class="config-item__label">
              使用多导航标签
              <span class="tip-btn-wrap">
                <el-popover
                  placement="top-start"
                  :width="260"
                  trigger="hover"
                  effect="dark"
                >
                  <section class="popover-wrap">
                    <section class="popover-wrap__title">多导航标签</section>
                    <section class="popover-wrap__content">
                      特殊配置请在 src/config/multipleNav/index.ts 中配置
                    </section>
                  </section>
                  <template #reference>
                    <el-icon><info-filled /></el-icon>
                  </template>
                </el-popover>
              </span>
            </span>
            <el-switch
              v-model="useMultipleNav"
              @change="changeHandle($event, 2)"
            />
          </section>

          <section class="config-item">
            <span>使用keep-alive</span>
            <el-switch
              v-model="useKeepAlive"
              @change="changeHandle($event, 3)"
            />
          </section>

          <!-- <section class="config-item">
            <span>显示顶部导航</span>
            <el-switch
              v-model="useHeader"
              @change="changeHandle($event, 4)"
            />
          </section> -->

          <section class="config-item">
            <span>显示左侧导航</span>
            <el-switch
              v-model="useSidebar"
              @change="changeHandle($event, 5)"
            />
          </section>
        </section>

        <el-divider />
        <h3 class="title">其他业务</h3>
        <section>
          <section class="config-item">
            <span class="config-item__label">
              SSO
              <span class="tip-btn-wrap">
                <el-popover
                  placement="top-start"
                  :width="260"
                  trigger="hover"
                  effect="dark"
                >
                  <section class="popover-wrap">
                    <section class="popover-wrap__title">集团SSO</section>
                    <ul class="popover-wrap__content">
                      <li>
                        1. 请在 src/config/index.ts 中修改sso配置
                      </li>
                      <li>
                        2. 请在 src/api/modules/user.ts 中获取用户权限接口和退出登录接口
                      </li>
                      <li>
                        3. 请在 src/store/modules/user.ts 中修改actions中的SET_MENUS
                      </li>
                    </ul>
                  </section>
                  <template #reference>
                    <el-icon><info-filled /></el-icon>
                  </template>
                </el-popover>
              </span>
            </span>
            <el-switch
              :value="false"
              :disabled="true"
            />
          </section>
          <section class="config-item">
            <span class="config-item__label">
              触点平台
              <span class="tip-btn-wrap">
                <el-popover
                  placement="top-start"
                  :width="260"
                  trigger="hover"
                  effect="dark"
                >
                  <section class="popover-wrap">
                    <section class="popover-wrap__title">触点平台</section>
                    <section class="popover-wrap__content">
                      请参考
                      <a
                        href="https://docs.zhugeio.com/dev/js.html"
                        target="_blank"
                      >
                        https://docs.zhugeio.com/dev/js.html
                      </a>
                    </section>
                  </section>
                  <template #reference>
                    <el-icon><info-filled /></el-icon>
                  </template>
                </el-popover>
              </span>
            </span>
            <el-switch
              :value="false"
              :disabled="true"
            />
          </section>
          <section class="config-item">
            <span class="config-item__label">
              APM
              <span class="tip-btn-wrap">
                <el-popover
                  placement="top-start"
                  :width="260"
                  trigger="hover"
                  effect="dark"
                >
                  <section class="popover-wrap">
                    <section class="popover-wrap__title">APM</section>
                    <section class="popover-wrap__content">
                      请参考
                      <a
                        href="https://wiki.longhu.net/pages/viewpage.action?pageId=100172163"
                        target="_blank"
                      >
                        https://wiki.longhu.net/pages/viewpage.action?pageId=100172163
                      </a>
                    </section>
                  </section>
                  <template #reference>
                    <el-icon><info-filled /></el-icon>
                  </template>
                </el-popover>
              </span>
            </span>
            <el-switch
              :value="false"
              :disabled="true"
            />
          </section>
          <section class="config-item">
            <span class="config-item__label">
              满意度
              <span class="tip-btn-wrap">
                <el-popover
                  placement="top-start"
                  :width="260"
                  trigger="hover"
                  effect="dark"
                >
                  <section class="popover-wrap">
                    <section class="popover-wrap__title">满意度</section>
                    <section class="popover-wrap__content">
                      请参考
                      <a
                        href="https://wiki.longhu.net/pages/viewpage.action?pageId=42772496"
                        target="_blank"
                      >
                        https://wiki.longhu.net/pages/viewpage.action?pageId=42772496
                      </a>
                    </section>
                  </section>
                  <template #reference>
                    <el-icon><info-filled /></el-icon>
                  </template>
                </el-popover>
              </span>
            </span>
            <el-switch
              :value="false"
              :disabled="true"
            />
          </section>
          <section class="config-item">
            <span class="config-item__label">
              IT报事
              <span class="tip-btn-wrap">
                <el-popover
                  placement="top-start"
                  :width="260"
                  trigger="hover"
                  effect="dark"
                >
                  <section class="popover-wrap">
                    <section class="popover-wrap__title">IT快捷报事</section>
                    <section class="popover-wrap__content">
                      请参考
                      <a
                        href="https://wiki.longhu.net/pages/viewpage.action?pageId=77271367"
                        target="_blank"
                      >
                        https://wiki.longhu.net/pages/viewpage.action?pageId=77271367
                      </a>
                    </section>
                  </section>
                  <template #reference>
                    <el-icon><info-filled /></el-icon>
                  </template>
                </el-popover>
              </span>
            </span>
            <el-switch
              :value="false"
              :disabled="true"
            />
          </section>
        </section>
      </section>
      <section class="copy-wrap">
        <el-divider />
        <section class="config-warning">
          <span style="margin-right: 8px;font-size: 16px;">
            <svg-icon icon-class="icon-notice" />
          </span>
          <div>
            配置栏只在开发环境用于预览，生产环境不会展现，请拷贝后手动修改配置文件(src/app.config.ts)。
          </div>
        </section>
        <section class="btn-copy">
          <el-button
            plain
            class="btn"
            :icon="DocumentCopy"
            @click="doCopyHandle"
          >
            拷贝设置
          </el-button>
        </section>
      </section>
    </section>
  </el-drawer>
</template>
<script lang="ts">
  import {
    ref, defineComponent, PropType, watch, reactive, toRefs,
  } from 'vue';
  import config from '@/app.config';
  import { useStore } from 'vuex';
  import {
    SET_BREADCRUMB_STATUS,
    SET_MULTIPLE_NAV_STATUS,
    SET_KEEPALIVE_STATUS,
    SET_LAYOUT,
    SET_NAVBAR_BACKGROUND,
    SET_SIDEBAR_BACKGROUND,
    SET_HEADER_STATUS,
    SET_SIDEBAR_STATUS,
  } from '@/store/actionTypes';
  import { DocumentCopy, InfoFilled } from '@element-plus/icons-vue';
  import { copyHandle } from '@/utils/index';
  import { ElMessage } from 'element-plus';
  import { setThemeColor, setTextColor } from '@/utils/resetElColor';

  type colorsType = {
    [key: string]: string
  }

  interface InterfaceState {
    layout: string,
    layoutList: string[],

    navbarBackgroundInfo: TypeObject,
    navbarBackgroundColors: TypeObject[],
    sidebarBackgroundInfo: TypeObject,
    sidebarBackgroundColors: TypeObject[],
    themeColors: colorsType,
    textColors: colorsType
  }

  export default defineComponent({
    name: 'setting-drawer',
    components: {
      InfoFilled,
    },
    props: {
      visible: {
        type: Boolean as PropType<false | true>,
        default: false,
      },
    },
    emits: {
      'update:visible': null,
    },
    setup(props, ctx) {
      const { getters, commit } = useStore();
      const useBreadcrumb = ref(getters.useBreadcrumb);
      const useMultipleNav = ref(getters.useMultipleNav);
      const useKeepAlive = ref(getters.useKeepAlive);
      const useHeader = ref(getters.useHeader);
      const useSidebar = ref(getters.useSidebar);

      const predefineColors = ref([
        '#007AF5',
        '#E22525',
        '#F76600',
        '#FAAB0C',
        '#FFD400',
        '#00D18B',
        '#00BCD4',
        '#0F76F5',
        '#455FE4',
        '#9746E8'
      ]);

      const state:InterfaceState = reactive({
        layout: 'side',
        layoutList: ['side', 'top', 'mix'],

        navbarBackgroundInfo: {
          key: 'default',
          background: '#fff',
        },
        navbarBackgroundColors: [
          {
            key: 'default',
            background: '#fff',
          },
          { 
            key: 'blue', // 海蓝色
            background: 'linear-gradient(90.08deg, #0F76F5 0%, #3F91F7 100%)',
          },
          { 
            key: 'cerulean', // 天蓝色、蔚蓝色
            background: 'linear-gradient(90.08deg, #4369EB 0%, #3D67D2 100%)',
          },
          { 
            key: 'indigo', // 靛蓝色
            background: 'linear-gradient(90.08deg, #33476F 0%, #395A84 100%)',
          },
          { 
            key: 'orange', // 橘黄色
            background: 'linear-gradient(90.27deg, #F76600 0%, #FA7D00 100%)',
          }
        ],
        sidebarBackgroundInfo: {
          key: 'indigo',
          background: 'radial-gradient(88.33% 20.76% at 96.39% 1.31%, #2B4D7C 0%, rgba(44, 58, 96, 0) 100%), radial-gradient(107.5% 39.69% at 50% 100%, #2B4D7C 0%, rgba(44, 58, 96, 0) 100%), radial-gradient(322.5% 75.78% at 119.17% 24.22%, #2B4D7C 0%, #2C3A60 100%)',
          
        },
        sidebarBackgroundColors: [
          {
            key: 'default',
            background: 'radial-gradient(155.32% 100% at 0% 0%, #F7FAFD 0%, #FBFCFE 25.86%, #FFFFFF 100%)',
          },
          {
            key: 'blue', 
            background: 'radial-gradient(102.22% 24.02% at 100% 0%, rgba(36, 145, 255, 0.2) 0%, rgba(0, 122, 245, 0) 100%), radial-gradient(107.5% 39.69% at 50% 100%, #3F91F7 0%, rgba(0, 127, 255, 0) 100%), radial-gradient(62.73% 62.73% at 107.5% 37.27%, #2478E4 0%, #007AF5 100%)',
          },
          { 
            key: 'cerulean', 
            background: 'radial-gradient(100% 31.53% at 100% 0%, #3A5EC9 0%, rgba(50, 85, 189, 0) 100%), radial-gradient(107.5% 39.69% at 50% 100%, #4664BF 0%, rgba(65, 97, 193, 0) 100%), radial-gradient(86.39% 69.26% at 136.39% 30.74%, #3A58B7 0%, #3154BC 100%)',
          },
          { 
            key: 'indigo', 
            background: 'radial-gradient(88.33% 20.76% at 96.39% 1.31%, #2B4D7C 0%, rgba(44, 58, 96, 0) 100%), radial-gradient(107.5% 39.69% at 50% 100%, #2B4D7C 0%, rgba(44, 58, 96, 0) 100%), radial-gradient(322.5% 75.78% at 119.17% 24.22%, #2B4D7C 0%, #2C3A60 100%)',
          },
          { 
            key: 'orange', 
            background: 'radial-gradient(120.28% 28.26% at 100% 1.63%, #FA7D01 0%, rgba(247, 102, 0, 0) 100%), radial-gradient(107.5% 39.69% at 50% 100%, #FA7D01 0%, rgba(247, 102, 0, 0) 100%), radial-gradient(65% 70.89% at 115% 29.11%, #F27B2C 0%, #F76600 100%)',
          }
        ],
        themeColors: { 
          ...config.themeColors, 
        },
        textColors: { 
          ...config.textColors, 
        },
      });

      /**
       * @description: switch按钮切换事件
       * @param {*} val switch按钮切换值
       * @param {*} type switch按钮类型
       *                 1: 使用面包屑
       *                 2: 使用多导航标签
       *                 3: 使用keep-alive控制路由
       */
      const changeHandle = (val:Event, type:number) => {
        if (type === 2) {
          commit(`app/${SET_MULTIPLE_NAV_STATUS}`, val);
        } else if (type === 3) {
          commit(`app/${SET_KEEPALIVE_STATUS}`, val);
        } else if (type === 4) {
          commit(`app/${SET_HEADER_STATUS}`, val);
        } else if (type === 5) {
          commit(`app/${SET_SIDEBAR_STATUS}`, val);
        } else {
          commit(`app/${SET_BREADCRUMB_STATUS}`, val);
        }
      };

      /**
       * @description: 改变顶部导航或者侧边栏背景色
       * @param {val} string
       * @return {type} number 1: 改变顶部导航别景色 2: 改变侧边栏背景色
       */
      const changeBackground = (val:TypeObject, type?: number) => {
        if (type === 1) {
          state.navbarBackgroundInfo = val;
          commit(`app/${SET_NAVBAR_BACKGROUND}`, val.key);
        } else if (type === 2) {
          state.sidebarBackgroundInfo = val;
          commit(`app/${SET_SIDEBAR_BACKGROUND}`, val.key);
        }
      };

      watch(
        [
          () => getters.useBreadcrumb,
          () => getters.useMultipleNav,
          () => getters.useKeepAlive
        ],
        ([useB, useM, useK]) => {
          useBreadcrumb.value = useB;
          useMultipleNav.value = useM;
          useKeepAlive.value = useK;
        },
        {
          immediate: true,
        }
      );

      return {
        ...toRefs(state),
        useBreadcrumb,
        useMultipleNav,
        useKeepAlive,
        useHeader,
        useSidebar,
        changeHandle,
        DocumentCopy,
        changeLayout: (val:string) => { // 改变layout
          state.layout = val;
          commit(`app/${SET_LAYOUT}`, val);
        },
        changeBackground,
        handleClose: () => {
          ctx.emit('update:visible', false);
        },
        doCopyHandle: () => {
          const copyInfo = {
            useBreadcrumb: useBreadcrumb.value,
            useMultipleNav: useMultipleNav.value,
            useKeepAlive: useKeepAlive.value,
            useHeader: useHeader.value,
            useSidebar: useSidebar.value,

            layout: state.layout,
            navbarBackground: state.navbarBackgroundInfo.key,

            sidebarBackground: state.sidebarBackgroundInfo.key,

            themeColors: state.themeColors,
            textColors: state.textColors,
          };
          copyHandle(JSON.stringify(copyInfo, null, '\t'));
          ElMessage({
            message: '拷贝成功，请到 src/app.config.ts 中替换默认配置',
            type: 'success',
          });
        },

        elColorChangeHandle: () => {
          setThemeColor(state.themeColors);
          setTextColor(state.textColors);
        },
        predefineColors,
      };
    },
  });
</script>
<style lang="scss" scoped>
.drawer-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .title {
    margin-bottom: $--base-space;
    color: $--color-grey1;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }

  .config-wrap {
    height: 100%;
    overflow-y: auto;

    .layout-wrap {
      display: flex;
      align-items: center;

      .layout__item {
        position: relative;
        width: 44px;
        height: 36px;
        margin-right: $--small-space;
        overflow: hidden;
        background-color: #F0F2F5;
        border-radius: 4px;
        box-shadow: 0 1px 2.5px 0 rgb(0 0 0 / 18%);
        cursor: pointer;

        &:before {
          position: absolute;
          top: 0;
          left: 0;
          width: 33%;
          height: 100%;
          content: '';
        }

        &.side:before {
          z-index: 1;
          background-color: #001529;
        }

        &.mix:before {
          background-color: $--color-white;
        }

        &:after {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 25%;
          content: '';
        }

        &.top:after {
          background-color: #001529;
        }

        &.side:after {
          background-color: $--color-white;
        }

        &.mix:after {
          z-index: 1;
          background-color: #001529;
        }

        .checked-wrap {
          position: absolute;
          right: 6px;
          bottom: 4px;
          color: #001529;
        }
      }
    }

    .colors-wrap {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .color-item {
        width: 26px;
        height: 26px;
        margin-right: 10px;
        line-height: 26px;
        text-align: center;
        border-radius: 2px;
        box-shadow: 0 1px 2.5px 0 rgb(0 0 0 / 18%);
        cursor: pointer;

        .checked-wrap {
          color: #fff;

          &.default {
            color: #001529;
          }
        }
      }
    }

    .config-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: $--base-space;

      .config-item__label {
        display: flex;
        align-items: center;

        .tip-btn-wrap {
          margin-left: 8px;
          cursor: pointer;
        }
      }
    }
  }

  .config-warning {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: $--base-space;
    padding: $--base-space;
    color: $--color-grey1;
    font-size: 14px;
    line-height: 20px;
    word-wrap: break-word;
    background-color: $--color-warning-deprecated-bg;
    border: 1px solid $--color-warning-deprecated-border;
    border-radius: 2px;
  }

  .btn-copy {
    margin-bottom: $--base-space;

    .btn {
      width: 100%;
    }
  }
}

.popover-wrap {
  color: $--color-white;

  .popover-wrap__title {
    font-weight: 500;
    font-size: 16px;
  }

  .popover-wrap__content {
    margin-top: 8px;
    font-size: 14px;

    a {
      color: $--color-white;

      &:hover {
        color: $--color-blue;
      }
    }
  }
}
</style>
